/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import withWidth, { isWidthDown, isWidthUp } from '@material-ui/core/withWidth';
import React from 'react';
import { compose } from 'redux';
import Page from '../../Components/Page/Page.component';
import ReportForm from '../../Components/ReportForm/ReportForm.component';
import reportsUrls from '../../Constants/Report/Report.constants';
import withServices from '../../Contexts/Services/WithServices.context';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import './Report.page.i18n';
import './DocketReport.page.i18n';
import ReportPagePropTypes from './Report.page.props';
import ReportPageSidebar from './Report.page.sidebar';
import reportPageStyles from './Report.page.styles';
/**
 * ReportPageComponent
 * @export
 * @class ReportPageComponent
 * @extends {React.Component<ReportPageComponentComposedProps, ReportPageComponentState>}
 */
export class ReportPageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<ReportPageComponentProps>}
   * @memberof ReportPageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`ReportPage`}
   * @memberof ReportPageComponent
   */
  static displayName = `ReportPage`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof ReportPageComponent
   */
  static propTypes = ReportPagePropTypes;

  /**
   * Data specific to the `<ReportPage />` instance
   * @type {ReportPageComponentState}
   * @memberof ReportPageComponent
   */
  state = {};

  /**
   * When the Component mounts, update it
   * @returns {void} void
   * @memberof ReportsPageComponent
   */
  async componentDidMount() {
    return;
  }

  /**
   * Render the component
   * @returns {React.Component} The rendered `<ReportPage />`
   * @memberof ReportPageComponent
   */
  render() {
    const { classes, reportType, width } = this.props;
    const isSmall = isWidthDown(`xs`, width);
    const isLarge = isWidthUp(`lg`, width);
    const heading = `${reportsUrls[reportType].i18nKey}.PageTitle`;
    return (
      <Page
        className={classes.root}
        heading={heading}
        hideLogo={isSmall}
        hideMenuIcon={isLarge}
        overflow="auto"
        sidebarContent={<ReportPageSidebar />}
        title={heading}
      >
        <ReportForm meta={reportsUrls[reportType]} />
      </Page>
    );
  }
}

/** @type {React.ComponentClass<ReportPageComponentProps>} */
const ReportPage = compose(
  withWidth(),
  withServices,
  withStyles(themeCreateInjectableStyles(reportPageStyles), { withTheme: true }),
)(ReportPageComponent);

export default ReportPage;
